var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoJcmMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 30,
    viewBox: "0 0 66 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.57743 22.165C8.62287 24.5198 7.90499 26.4196 6.50558 27.8557C5.06074 29.3363 2.68902 30.0588 0.144639 29.9964L0.126465 28.2035C1.88027 28.1589 2.98889 27.5078 3.46142 26.2323C3.67951 25.6347 3.80673 24.3235 3.85216 22.2899C3.87033 21.059 3.85216 0.642119 3.85216 0.2229H8.58652C8.57743 0.2229 8.57743 21.8707 8.57743 22.165Z",
    fill: "#42474E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M60.8484 23.3781L58.84 6.70742L50.3524 23.3781H48.5713L39.8838 6.70742L38.5206 23.3781H35.7944L38.0935 0.2229H41.8194L50.8613 17.2682L59.4125 0.249659H62.784L65.8282 23.3781H60.8484Z",
    fill: "#42474E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.9695 23.0125C29.7522 23.6457 27.026 23.9222 24.736 23.9222C17.9386 23.9222 12.3862 18.7578 12.3862 12.0146C12.3862 4.60249 18.5384 0 25.6992 0C27.7076 0 30.0975 0.419219 31.9877 0.945472L31.9605 2.77398C30.561 2.49748 29.0616 2.24773 27.6258 2.24773C21.4736 2.24773 17.8568 5.94042 17.8568 11.9433C17.8568 17.9818 21.4009 21.7102 27.6258 21.7102C29.0616 21.7102 30.561 21.4961 31.9605 21.1839L31.9695 23.0125Z",
    fill: "#42474E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.79521 26.4822C9.49533 27.0174 9.13183 27.5168 8.69563 27.9628C8.5775 28.0877 8.44119 28.1947 8.31396 28.3107H65.8735V26.4822H9.79521Z",
    fill: "#38939C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoJcmMini);
export default __webpack_public_path__ + "static/media/logoJcmMini.f34afd3c7e3c6b55809d9c3209d3cdb0.svg";
export { ForwardRef as ReactComponent };